import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { SchedulesState } from '@/store/schedules/types';
import mutations from './mutations';
import actions from './actions';
import getters from './getters'

const Schedules: Module<SchedulesState, RootState> = {
  state: {
    schedules: [],
  },
  mutations,
  actions,
  getters,
};

export default Schedules;
